import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { get_request_config, LIST_TEMPLATE_VIEW_URL } from '@/utils/system_constants/constant';

export default{
  name: 'TemplateManagement',
  mixins: [alert_mixin],
  data() {
    return {
      search_query: '',
      current_page: 1,
      page_size: 4,
      loading: false,
      metrics: {
        total_templates: 142,
        active_assignments: 89,
      },
      templates: [],
      selected_template: null,
      entity_types: [],
      assign_entity_type_id: '',
    }
  },
  mounted(){
    this.get_uploaded_template()
  },
  computed: {
    filtered_templates() {
      const query = (this.search_query || '').toLowerCase().trim();
      if (!query) return this.templates;

      return this.templates.filter((tpl) => {
        const haystack = `${tpl.name} ${tpl.description} ${tpl.type}`.toLowerCase();
        return haystack.includes(query);
      });
    },
    total_pages() {
      const pages = Math.ceil(this.filtered_templates.length / this.page_size);
      return Math.max(1, pages);
    },
    paginated_templates() {
      const start = (this.current_page - 1) * this.page_size;
      const end = start + this.page_size;
      return this.filtered_templates.slice(start, end);
    },
    pagination_label() {
      const total = this.filtered_templates.length;
      if (!total) return `0 of 0 results`;

      const start = (this.current_page - 1) * this.page_size + 1;
      const end = Math.min(this.current_page * this.page_size, total);
      return `${start} to ${end} of ${total} results`;
    }
  },
  watch: {
    search_query() {
      this.current_page = 1;
    }
  },
  methods: {
    parse_response_data(payload) {
      if (typeof payload !== 'string') {
        return payload;
      }

      const trimmed = payload.trim();
      if (!trimmed) {
        return {};
      }

      try {
        return JSON.parse(trimmed);
      } catch (error) {
        return {
          status: 'error',
          message: 'Invalid JSON response received from the server.'
        };
      }
    },
    go_to_upload_template() {
      this.$router.push({ name: 'UploadTemplate' });
    },
    set_page(page) {
      const next = Math.min(Math.max(1, page), this.total_pages);
      this.current_page = next;
    },
    preview_template(template) {
      this.selected_template = {
        ...template,
        preview_url: template.presigned_url
      };
    },
    assign_template(template) {
      this.selected_template = template;
      this.assign_entity_type_id = '';
    },
    confirm_assign() {
      this.selected_template = null;
      this.assign_entity_type_id = '';
    },
    async get_uploaded_template() {


      this.loading = true;

      try {
        // Fetch only e-signing templates for this view
        const esign_response = await axios.get(LIST_TEMPLATE_VIEW_URL, get_request_config());
        const esign_response_data = this.parse_response_data(esign_response.data);

        if (esign_response_data.status === "success") {
          const formatDate = (value) => {
            if (!value) return '';
            const dt = new Date(value);
            if (Number.isNaN(dt.getTime())) return '';
            return new Intl.DateTimeFormat('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric'
            }).format(dt);
          };

          this.templates = (esign_response_data.data || []).map((template) => ({
            id: template.id,
            name: template.name || template.template_name,
            description: template.description || template.template_description,
            type: template.template_type || template.type || "e-signing",
            date_uploaded: template.date_uploaded || formatDate(template.created_at || template.updated_at),
            url: template.url || template.document_url || template.presigned_url,
            presigned_url: template.presigned_url,
          }));

          this.metrics.total_templates = this.templates.length;
        } else {
          this.show_error(esign_response_data.message || "Failed to load e-signing templates");
        }
      } catch (error) {
        this.show_error(
          `Error fetching templates: ${error.response?.data?.message || error.message
          }`
        );
      } finally {
        this.loading = false;
      }
    },

  },
}
